$(document).ready(function() {
    const tabs = $(".js-block-videos");

    let buttons = $(".js-videos-tab");
    let activeButton = buttons.filter(".active").attr("tab");
    let defaultFilter = "#all";

    tabs.each(function() {
        let tabName = $(this).attr("id");

        $(this).find(".pagination a").each(function() {
            $(this).attr("href", $(this).attr("href") + "&tab=" + tabName);
        });
    });

    buttons.click(function(){
        let filter = $(this).hasClass("active") ? defaultFilter : $(this).attr("tab");

        tabs.hide();
        tabs.filter(filter).show();
        buttons.removeClass("active");

        if (filter !== defaultFilter) {
            $(this).addClass("active");
        }

        return false;
    });

    if (activeButton) {
        tabs.hide().filter(activeButton).show();
    }
});
